
import { Component, Mixins, } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../components/system";

@Component
export default class SyntaxEditorMixin extends Mixins(ModelEditableMixin) {
  get editorStyle(): any {
    return {
      "--placeholder-color": this.noticeIndicationColor,
    };
  }

  get noticeIndicationColor(): string {
    return this.$configuration.style.noticeIndication.color;
  }

  get noticeIndicationBackgroundColor(): string {
    return this.$configuration.style.noticeIndication.backgroundColor;
  }
}
